import React from "react";
import { Card } from "primereact/card";

export const NoAiSummaries: React.FC = () => {
    return (
        <Card className="mt-4">
            <div className="flex flex-column align-items-center justify-content-center p-6">
                <i className="pi pi-info-circle text-6xl text-blue-500 mb-3"></i>
                <h3 className="text-center text-blue-900 mb-2">No AI Summaries Available</h3>
                <p className="text-center text-600 max-w-30rem">
                    For AI Summaries to appear for this inspection, text generation needs to be run first.
                </p>
            </div>
        </Card>
    );
};